import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { Chart } from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import Loader from "../../../components/ui/Loader/Loader";
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import DateService from "../../../services/DateService";
import Status from "../../../components/ui/Status";

const DealWidget = (props) => {

    const widgetUrl = INVENTORY_API_BASE_URL_2 + "/deal_widget_data"
    const dealTypesUrl = INVENTORY_API_BASE_URL_2 + "/deal_widget_formdata"
    const updateMyDashboardRef = useRef();
    const access_token = useSelector(state => state.auth.access_token);
    const widget_keys = useSelector(state => state.app.user_info?.widget_keys || []);

    const [widgetData, setWidgetData] = useState(null)

    const [formData, setFormData] = useState({
        userFilters: [
            { value: 'tagged_me', label: 'My Tagged Deal' },
            { value: 'created_by_me', label: 'Deal Created By Me' },
        ],
        dealTypeFilters: [],
        filterData: {
            canChange: false,
            search_deal_type_id: '',
            tagged_user_filter: ""
        }
    });

    const [dealData, setDealData] = useState({
        loading: false,
        data: [],
        remark_time: '',
    });
    const [reload, setReload] = useState(false);

    const fetchFormData = () => {
        const cachedFormData = localStorage.getItem("deal_widget_formdata");
        if (cachedFormData) {
            setFormData(prev => ({
                ...prev,
                dealTypeFilters: JSON.parse(cachedFormData)
            }));
            return;
        }

        HttpAPICall.withAthorization(
            'GET',
            dealTypesUrl,
            access_token,
            {},
            {},
            (response) => {
                const data = response.data?.deals;
                if (data) {
                    const formattedDealTypes = data.map(dealType => ({
                        value: dealType?.id,
                        label: dealType?.name
                    }));

                    localStorage.setItem(
                        "deal_widget_formdata",
                        JSON.stringify(formattedDealTypes)
                    );

                    setFormData(prev => ({
                        ...prev,
                        dealTypeFilters: formattedDealTypes
                    }));
                }
            }
        );
    };


    useEffect(() => {
        if (!formData.filterData.canChange) return;
        dealWidgetData();
    }, [formData.filterData]);

    useEffect(() => {
        fetchFormData();

        const widget =
            widget_keys?.length > 0
                ? widget_keys.find(w => w.key === "isc_deal_status_wise_widget")
                : null;

        setWidgetData(widget);
    }, []);



    useEffect(() => {
        setDealData(prev => ({ ...prev, loading: true }));
        if (localStorage.getItem('dealWidget')) {
            const leadData = JSON.parse(localStorage.getItem('dealWidget'));
            if (leadData) {
                let diff = DateService.differenceInSeconds(
                    moment(leadData.time, 'DD-MM-YYYY HH:mm A').format()
                );

                if (diff <= 86400) {
                    setDealData(prev => ({
                        ...prev,
                        data: leadData.data,
                        loading: false,
                        remark_time: leadData.time,
                    }));
                    return;
                }
                localStorage.removeItem('dealWidget');
            }
        }

        //setTimeout(() => {
            dealWidgetData();
       // }, 1000 * (props.indexProps || 12));
    }, []);
    useEffect(() => {
        if (!reload) return;

        dealWidgetData();
    }, [reload]);

    const dealWidgetData = () => {
        setDealData(prev => ({ ...prev, loading: true }));

        let params = {
            ...formData.filterData,
            reload: reload ? 'reload' : false
        };

        HttpAPICall.withAthorization('GET', widgetUrl, access_token, params, {}, (response) => {
            const res = response.data;
            setDealData(prev => ({
                ...prev,
                data: res.data,
                remark_time: res.time
            }));

            if (!formData.filterData.search_deal_type_id && !formData.filterData.tagged_user_filter) {
                localStorage.setItem('dealWidget', JSON.stringify(res));
            }
            if (reload) {
                localStorage.setItem('dealWidget', JSON.stringify(res));
            }
        }).then(() => {
            setDealData(prev => ({ ...prev, loading: false }));
            setReload(false);
            setFormData(prev => ({
                ...prev,
                filterData: {
                    ...prev.filterData,
                    canChange: false
                }
            }))
        });
    };




    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, {
            key: "isc_deal_status_wise_widget",
            name: "Deal Status wise Widget"
        });
    };

    const handleCountClick = (data) => {
        const statusId = data.id;
        const taggedUserFilter = formData.filterData.tagged_user_filter;
        const dealType = formData.filterData.search_deal_type_id;

        const params = new URLSearchParams();
        if (statusId) {
            params.append('status_id', statusId);
        }
        if (taggedUserFilter) {
            params.append('tagged_user_filter', taggedUserFilter);
        }
        if (dealType) {
            params.append('search_deal_type_id', dealType);
        }

        const url = `/deals?${params.toString()}`;
        window.open(url, '_blank');
    };

    const handleSubStatusCountClick = (data) => {
        console.log(data);
        
        const subStatusId = data.id;
        const taggedUserFilter = formData.filterData.tagged_user_filter;
        const dealType = formData.filterData.search_deal_type_id;

        const params = new URLSearchParams();
        if (subStatusId) {
            params.append('subStatus_id', subStatusId);
        }
        if (taggedUserFilter) {
            params.append('tagged_user_filter', taggedUserFilter);
        }
        if (dealType) {
            params.append('search_deal_type_id', dealType);
        }

        const url = `/deals?${params.toString()}`;
        window.open(url, '_blank');
    };
    const handleTotalClick = () => {
        const statusIds = dealData.data.map(item => item.id);
        console.log(statusIds);
        

        const params = new URLSearchParams();

        params.append("status_ids", statusIds.join(","));

        const taggedUserFilter = formData.filterData.tagged_user_filter;
        const dealType = formData.filterData.search_deal_type_id;

        if (taggedUserFilter) {
            params.append("tagged_user_filter", taggedUserFilter);
        }

        if (dealType) {
            params.append("search_deal_type_id", dealType);
        }

        window.open(`/deals?${params.toString()}`, "_blank");
    };

    const totalValue = dealData.data.reduce((acc, d) =>
        acc + (parseInt(d.total_deals) > 0 ? parseInt(d.total_deals) : 0), 0);

    const chartData = dealData.data && dealData.data.length > 0
        ? [['Status Name', 'Deals Count']].concat(
            dealData.data.map(d => [d.name, parseInt(d.total_deals) || 0])
        )
        : [];

    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color mb-0">Deal Widget</h6>
                    </div>
                    <div className="col-3">
                        <TapSelect
                            options={formData.userFilters}
                            changeEvent={(selectedOption) => {
                                setFormData(prev => ({
                                    ...prev,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        tagged_user_filter: selectedOption ? selectedOption.value : ""
                                    }
                                }));
                            }}
                            value={formData.userFilters.find(u => u.value === formData.filterData.tagged_user_filter)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="100%"
                            placeholder="All Deal"
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.dealTypeFilters}
                            changeEvent={(selectedOption) => {
                                setFormData(prev => ({
                                    ...prev,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        search_deal_type_id: selectedOption ? selectedOption.value : ""
                                    }
                                }));
                            }}
                            value={formData.dealTypeFilters.find(u => u.value === formData.filterData.search_deal_type_id)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="100%"
                            placeholder="All Deal Types"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <div className="dropdown">
                            <tapIcon.imageIcon
                                icon={tapIcon.ListActionIcon}
                                alt="action-icon"
                                className="img-fluid px-2 btn btn-light btn-block"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-expanded="false"
                            />
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>
                                    Refresh
                                </li>
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>
                                    {!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-6">
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                            <table className="table table-hover table-bordered table-sm bg-white">
                                <thead className="table-secondary">
                                    <tr className="text-center">
                                        <th style={{ width: "60%" }}>Status</th>
                                        <th style={{ width: "40%" }}> Count </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dealData?.data?.map((item) => (
                                        <React.Fragment key={item.id}>

                                            <tr className="bg-light" >
                                                <td className="fw-bold" style={{ paddingLeft: "10px" }}>
                                                    <Status color={item.color} /> {item.name}
                                                </td>

                                                <td className="text-center">
                                                    <span
                                                        className="text-primary"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleCountClick(item)}
                                                    >
                                                        {item.total_deals}
                                                    </span>
                                                </td>
                                            </tr>

                                            {item.sub_status_data?.map((subStatus) => (
                                                <tr key={subStatus.id}>
                                                    <td style={{ paddingLeft: "40px" }}>
                                                        <Status color={subStatus.color} />{" "}
                                                        {subStatus.name}
                                                    </td>

                                                    <td className="text-center">
                                                        <span
                                                            className="text-primary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() =>
                                                                handleSubStatusCountClick(subStatus)
                                                            }
                                                        >
                                                            {subStatus.total_deals}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                                {!dealData.loading && dealData.data && dealData.data.length > 0 && (
                                    <tfoot>
                                        <tr className="fw-bold">
                                            <td>Total Deals</td>
                                            <td
                                                className="text-center text-primary"
                                                style={{ cursor: "pointer" }}
                                                onClick={handleTotalClick}
                                            >
                                                {totalValue}
                                            </td>
                                        </tr>
                                    </tfoot>
                                )}
                            </table>
                        </div>
                    </div>

                    <div className="col-6 p0 mt-3 mb-1">
                        {dealData.loading ? (
                            <Loader />
                        ) : (dealData.data && totalValue > 0 ? (
                            <Chart
                                chartType="PieChart"
                                data={[['Status Name', 'Deals Count']].concat(dealData.data.map((d) => { return [d.name, d.total_deals]; }))}
                                options={{
                                    legend: { position: 'labeled', labeledValueText: 'both' },
                                    pieSliceText: 'none',
                                    chartArea: { width: '90%', height: '90%' },
                                }}
                                rootProps={{ 'data-testid': '1' }} />
                        ) : null)}
                    </div>
                </div>

                <div className="col-sm-12 text-muted fs11">
                    Report as of {dealData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />
        </div>
    );
};

export default DealWidget;